/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import PubSub from 'pubsub-js';
import _ from 'lodash';

const deps = {};

/*---------------------------------------------------------*\
 * HeaderMainController
\*---------------------------------------------------------*/
class HeaderMainController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($scope, $q, $state, $timeout, categoryService, tickerService, navigationService, localService,
              storageKeys, topics) {
    deps.$state = $state;
    deps.$scope = $scope;
    deps.$timeout = $timeout;
    deps.categoryService = categoryService;
    deps.tickerService = tickerService;
    deps.navigationService = navigationService;
    deps.localService = localService;
    deps.storageKeys = storageKeys;
    deps.topics = topics;

    // Only load menu and ticker if the parent did not request to hide the bar
    if (!this.headerConfig || !this.headerConfig.hideNavbar) {
      // parallelize requests to speed up rendering
      $q.all([
        this.loadMenu(),
        this.loadTicker()
      ]).then((values) => {
        const menu = values[0];
        if (this.tickerData.type) {
          this.setAlertBadge(menu, this.tickerData.type);
        }
      });
    }

    this.name = 'headerMain';
    const token1 = PubSub.subscribe(deps.topics.headerMain.resetSubnav, () => {
      deps.$timeout(() => {
        if (this.subMenuItems) {
          this.selectSubMenuItem(this.subMenuItems[0]);
        }
      });
      this.hideBlur();
    });

    deps.$scope.$on('$destroy', () => {
      PubSub.unsubscribe(token1);
    });
  }

  //-----------------------------------
  // Methods
  //-----------------------------------

  loadMenu() {
    const regionId = this.region ? this.region.abbr : 'LI';
    // fetch navigation data
    return deps.categoryService.getCategories(regionId)
      .then((menu) => {
        deps.$timeout(() => {
          this.navItems = menu;
          this.selectedIndex = this.getRouteIndex();
          this.onMenuReady(menu);
        });
        return menu;
      });
  }

  loadTicker() {
    const regionId = this.region ? this.region.abbr : 'LI';
    return deps.tickerService.getTicker(regionId)
      .then((res) => {
        if (!res.data) {
          return [];
        }
        this.tickerData = {
          type: res.data.rss.channel.item.title,
          message: res.data.rss.channel.item.content
        };
        return res.data;
      });
  }

  getRouteIndex() {
    const states = _.map(this.navItems, 'state');
    return states.indexOf(deps.$state.current.name);
  }

  setAlertBadge(menu, type) {
    const types = {
      'WEATHER ALERT': 'weather',
      'TRAFFIC ALERT': 'traffic'
    };
    const id = types[type];
    menu.forEach((item) => {
      item.badge = item.id === id ? 'Alert' : null;
    });
  }

  onMenuReady(menu) {
    PubSub.publish(deps.topics.headerMain.menuReady, {
      menu,
      activeTab: menu[this.selectedIndex]
    });
  }

  selectTab(item) {
    const previousItem = this.navItems[this.selectedIndex];
    this.selectedIndex = this.navItems.indexOf(item);
    this.subMenuItems = item.sections;

    // only show submenu if there are multiple items
    if (Array.isArray(item.sections) && item.sections.length > 1) {
      this.showSubMenu = true;

      deps.navigationService.focusElAsync('navbar-sub-menu');
    }

    PubSub.publish(deps.topics.headerMain.selectTab, {
      item,
      previousItem
    });

    // notify ad component to refresh its ads
    PubSub.publish(deps.topics.ads.refreshAd);
  }

  selectSubMenuItem(item) {
    this.showSubMenu = false;
    PubSub.publish(deps.topics.headerMain.selectSection, item);

    // notify ad component to refresh its ads
    PubSub.publish(deps.topics.ads.refreshAd);
  }

  hideBlur() {
    deps.$timeout(() => {
      this.showSubMenu = false;
    });
  }
}

HeaderMainController.$inject = [
  '$scope',
  '$q',
  '$state',
  '$timeout',
  'categoryService',
  'tickerService',
  'navigationService',
  'localService',
  'storageKeys',
  'topics'
];

export default HeaderMainController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/headerMain/headerMain.controller.js
 **/